export function PageHeader({ title, subtitle, actions, testid }) {
  return (
    <div className="employee-page-header flex flex-col sm:flex-row items-start justify-between gap-4 border-b border-zinc-200 px-4 sm:px-6 py-4 sm:py-5 bg-white" data-testid={testid || "page-header"}>
      <div className="min-w-0">
        <h1 className="font-heading font-black text-2xl tracking-tight text-zinc-950">{title}</h1>
        {subtitle && <p className="text-xs text-zinc-500 mt-1 max-w-xl">{subtitle}</p>}
      </div>
      {actions && <div className="flex w-full sm:w-auto flex-wrap items-center gap-2 sm:shrink-0">{actions}</div>}
    </div>
  );
}

export function Card({ children, className = "", testid }) {
  return <div className={`employee-card border border-zinc-200 bg-white rounded-sm ${className}`} data-testid={testid}>{children}</div>;
}

export function Stat({ label, value, hint, testid }) {
  return (
    <Card testid={testid} className="employee-stat p-4">
      <div className="text-[11px] font-semibold uppercase tracking-wider text-zinc-500">{label}</div>
      <div className="font-heading font-black text-3xl mt-1 tracking-tight text-zinc-950">{value}</div>
      {hint && <div className="text-[11px] text-zinc-500 mt-1">{hint}</div>}
    </Card>
  );
}

export function Btn({ children, variant = "default", ...props }) {
  const base = "employee-btn inline-flex items-center justify-center gap-1.5 text-sm font-semibold rounded-sm px-3 py-1.5 transition-colors disabled:opacity-50";
  const v = {
    default: "bg-zinc-950 text-white hover:bg-zinc-800",
    outline: "border border-zinc-300 text-zinc-900 hover:bg-zinc-100",
    ghost: "text-zinc-900 hover:bg-zinc-100",
    danger: "bg-red-600 text-white hover:bg-red-700",
    primary: "bg-sky-500 text-white hover:bg-sky-600",
  }[variant];
  return <button className={`${base} ${v}`} {...props}>{children}</button>;
}

export function Input(props) {
  return <input {...props} className={`employee-input border border-zinc-300 rounded-sm px-2.5 py-1.5 text-sm focus:outline-none focus:ring-1 focus:ring-zinc-950 ${props.className || ""}`} />;
}

export function Select({ children, ...props }) {
  return <select {...props} className={`employee-select border border-zinc-300 rounded-sm px-2 py-1.5 text-sm bg-white focus:outline-none focus:ring-1 focus:ring-zinc-950 ${props.className || ""}`}>{children}</select>;
}

export function Field({ label, children }) {
  return (
    <label className="block">
      <div className="employee-field-label text-[11px] font-semibold uppercase tracking-wider text-zinc-500 mb-1">{label}</div>
      {children}
    </label>
  );
}

export function Chip({ children, tone = "neutral" }) {
  const t = {
    neutral: "bg-zinc-100 text-zinc-800",
    good: "bg-emerald-100 text-emerald-800",
    warn: "bg-amber-100 text-amber-800",
    bad: "bg-red-100 text-red-800",
    info: "bg-sky-100 text-sky-800",
  }[tone];
  return <span className={`employee-chip chip ${t}`}>{children}</span>;
}
